
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gOINVf_459pNwx7Mis_45sR2dtAHjaFM0n7HY33bTyyp_qj8Meta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indext0ghnKIR00tm35cMWvLp_I4H9M7BmkNHXNZvZm40tX4Meta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchSBJPfCNqmlKWRl40Aza4vmzyfwdnRF5rI5wNN4kFNXcMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexJ8O3GfU1kSbJuo6KrYBDewQudFDVL96pLMbkjDGAINMMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93cdB80Nf23r4HiyTbxWCq_0Ke1DIhDkwkRqw6ZSUN2qUMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexPFgUYXfUSup_ptbJM5n_45eB_hPp2ic31qM30RuG_j_45X8Meta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93oqgQFbBkDd6jvZjuz2c2OrCWMOz9VrfUtjthzxL6I0QMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexLPfu7_45hr6PZO7RvTZa3tZQ1rKbnwR78WyaC5FQY23ncMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_932sP6_IctfbJxM1hvH7DmovSCyVp8zVpxY7B6DA0ooD8Meta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexQrqieUfy04aLzyfhvF2ehtHb6UYq7eh6c_769negFQQMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexAuhVY63PsQEI37G0WUb_45EQAAdpCydVgAvJsb_UEiNVgMeta } from "/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexPFgUYXfUSup_ptbJM5n_45eB_hPp2ic31qM30RuG_j_45X8Meta || {},
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexLPfu7_45hr6PZO7RvTZa3tZQ1rKbnwR78WyaC5FQY23ncMeta || {},
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexQrqieUfy04aLzyfhvF2ehtHb6UYq7eh6c_769negFQQMeta || {},
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexAuhVY63PsQEI37G0WUb_45EQAAdpCydVgAvJsb_UEiNVgMeta || {},
    component: () => import("/codebuild/output/src2214828111/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]